package io.horion.auth.di

import io.horion.auth.domain.usecase.AuthUseCase
import io.horion.auth.domain.usecase.ProfileUseCase
import org.koin.dsl.module

val useCaseModule = module {
    single { AuthUseCase() }
    single { ProfileUseCase(get()) }
}